import React from "react";
import { ToggleSwitch } from "../../../../components";
import { addCurrencyWord } from "../../../../utils";
import styles from "./RacketToggleCard.module.scss";

export interface RacketToggleCardProps {
  checked: boolean;
  onToggle: (checked: boolean) => void;
}

export const RacketToggleCard: React.FC<RacketToggleCardProps> = ({
  checked,
  onToggle,
}) => {
  return (
    <div className={styles.racketCardContent}>
      <div className={styles.racketCardInfo}>
        <p className={styles.racketCardTitle}>
          Мне нужны ракетки
        </p>
        <p className={styles.racketCardPrice}>
          {addCurrencyWord(500)} в час
        </p>
      </div>
      <ToggleSwitch
        checked={checked}
        onChange={onToggle}
        id="racket-toggle"
      />
    </div>
  );
};
